import { Plus, Trash2 } from "lucide-react";

export const STATUS = {
  pending: { label: "Pending approval", cls: "bg-amber-100 text-amber-800" },
  confirmed: { label: "Confirmed", cls: "bg-emerald-100 text-emerald-800" },
  completed: { label: "Completed", cls: "bg-slate-200 text-slate-700" },
  canceled: { label: "Canceled", cls: "bg-red-100 text-red-700" },
  rejected: { label: "Rejected", cls: "bg-red-100 text-red-700" },
};

export const StatusBadge = ({ status }) => (
  <span data-testid={`status-${status}`} className={`inline-block rounded-full px-2.5 py-1 text-xs font-semibold ${STATUS[status]?.cls}`}>
    {STATUS[status]?.label || status}
  </span>
);

export const inputCls = "w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-[#0B132B] focus:border-gold focus:outline-none";

export const Labeled = ({ label, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">{label}</span>
    {children}
  </label>
);

export const Panel = ({ title, action, children }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-6">
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
      <h2 className="font-display text-lg font-bold text-[#0B132B]">{title}</h2>
      {action}
    </div>
    {children}
  </div>
);

export const SaveButton = ({ onClick, saving, testid }) => (
  <button type="button" onClick={onClick} disabled={saving} data-testid={testid}
    className="rounded-full bg-[#0B132B] px-5 py-2 text-sm font-semibold text-white hover:bg-gold hover:text-[#0B132B] disabled:opacity-60">
    {saving ? "Saving…" : "Save changes"}
  </button>
);

export const NamedList = ({ rows, onChange, amountKey, amountLabel, testid }) => {
  const upd = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div className="space-y-2" data-testid={testid}>
      {rows.map((r, i) => (
        <div key={i} className="flex gap-2">
          <input className={inputCls} value={r.name} placeholder="Name" onChange={(e) => upd(i, "name", e.target.value)} data-testid={`${testid}-name-${i}`} />
          <input className={`${inputCls} w-32`} type="number" min="0" value={r[amountKey]} placeholder={amountLabel}
            onChange={(e) => upd(i, amountKey, Number(e.target.value))} data-testid={`${testid}-amount-${i}`} />
          <button type="button" onClick={() => onChange(rows.filter((_, j) => j !== i))} className="px-2 text-slate-400 hover:text-red-600" data-testid={`${testid}-remove-${i}`}>
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...rows, { name: "", [amountKey]: 0 }])} data-testid={`${testid}-add`}
        className="inline-flex items-center gap-1 text-sm font-semibold text-gold"><Plus className="h-4 w-4" /> Add</button>
    </div>
  );
};

export const fmt12 = (t) => {
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};
